import { render, staticRenderFns } from "./setToexamine.vue?vue&type=template&id=01443691&scoped=true&"
import script from "./setToexamine.vue?vue&type=script&lang=js&"
export * from "./setToexamine.vue?vue&type=script&lang=js&"
import style0 from "./setToexamine.vue?vue&type=style&index=0&id=01443691&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01443691",
  null
  
)

export default component.exports